import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './vuex/store.js'
import VueCookies from 'vue-cookies'
import language from './language'
import md5 from 'js-md5'
import * as Base64 from 'js-base64'
/***
 * 每次路由跳转都到页面顶部
 */
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
  // 或
  // window.scroll(0, 0);
  });
  // 或
  // router.afterEach((to,from,next) => {
  // document.body.scrollTop =0;
  // document.documentElement.scrollTop = 0;
  // });
  
Vue.use(VueAxios,axios);
Vue.prototype.$al = language
Vue.prototype.$md5 = md5
Vue.prototype.Base64 = Base64
Vue.config.productionTip = false
//全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI, {locale})
Vue.use(VueCookies)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js